import React, { useState } from "react";
import { useLocation, useOutletContext } from "react-router-dom";
import { CalendarToday, CalendarTodayOutlined } from "@mui/icons-material";
import "./ApprovedBook.css"; // Using the same styling as ApprovedBook
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import TelegramBackButton from "../../../components/TelegramBackButton.jsx";
import { useTranslation } from "react-i18next";
import LoadingAnim from "../../../components/LoadingAnim.jsx";
import defaultImage from "../../../assets/default.png";

import wifi from "../../../assets/Icons/facilities/wifi.png";
import tv from "../../../assets/Icons/facilities/tv.png";
import shower from "../../../assets/Icons/facilities/shower.png";
import workspace from "../../../assets/Icons/facilities/workspace.png";
import airCondition from "../../../assets/Icons/facilities/air_condition.png";
import balcony from "../../../assets/Icons/facilities/balcony.png";
import heating from "../../../assets/Icons/facilities/heating.png";
import kitchen from "../../../assets/Icons/facilities/kitchen.png";
import privateBathroom from "../../../assets/Icons/facilities/bathroom.png";
import laundry from "../../../assets/Icons/facilities/laundry.png";
import locationImg from "../../../assets/Icons/location_icon.png";
import BookCancelModal from "./Components/BookCancelModal.jsx";
import BookCancelSuccess from "./Components/BookCancelSuccess.jsx";
import { API_BASE_URL, API_KEY } from "../../../config.js";

const PendingBook = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const property = location.state?.property;
  //console.log("Property data:", property);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const { toggleFooter } = useOutletContext();
  const [showCancelModal, setShowCancelModal] = useState(false);

  if (!property) {
    return <LoadingAnim />;
  }

  if (showCancelModal) {
    return <BookCancelSuccess onClose={() => setShowCancelModal(false)} />;
  }

  const openModal = () => {
    setIsModalOpen(true);
    toggleFooter(false);
    setShowCancelModal(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    toggleFooter(true);
    setShowCancelModal(false);
  };

  const handleConfirmCancel = async (propertyId, username) => {
    const userData = {
      reservationId: propertyId,
      username: username,
    };

    console.log("User data for cancellation:", userData);

    try {
      const initData = window.Telegram.WebApp.initData;
      const response = await fetch(
        `${API_BASE_URL}/user/api/v1/reservation/reject/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": API_KEY,
            "X-Telegram-InitData": initData,
          },
          body: JSON.stringify(userData),
        }
      );

       const data = await response.json();
      console.log("Cancellation response:", data);

      if (response.ok) {
        setShowCancelModal(false);
        setIsModalOpen(false);
      } else {
        setShowCancelModal(false);
        throw new Error(
          `HTTP error! Status: ${response.status} - ${response.statusText} Message: ${data.message || "No message provided"}`
        );
         window.Telegram.WebApp.showAlert(
          ":( Error occurred while canceling booking!"
        );
      }
    } catch (error) {
      console.error("Error during cancellation:", error);
    }
  };

  const items = property.house.sub_description
    ? property.house.sub_description.replace(/^,/, "").split(",")
    : [];

  const emojiMap = {
    "Wi-Fi": wifi,
    "Hot Shower": shower,
    "Private Bathroom": privateBathroom,
    "Workspace/Desk": workspace,
    "Air Conditioning": airCondition,
    "Kitchen Access": kitchen,
    "Balcony or Terrace": balcony,
    Heating: heating,
    TV: tv,
    "Laundry Facilities": laundry,
  };

  const facilitiesToRender = items.slice(1);

  return (
    <>
      <TelegramBackButton />

      <div className="max-w-sm mx-auto bg-white text-white p-4 rounded-lg">
        <Swiper pagination={true} modules={[Pagination]} className="mySwiper">
          {(property.house?.houseImage || []).map((img, index) => (
            <SwiperSlide key={index}>
              <img
                src={img.image}
                alt={`property-${index}`}
                className="w-full h-auto"
                style={{
                  maxHeight: "200px",
                  borderRadius: "10px",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
        <br />
        <div>
          <p className="text-lg font-bold text-black">{property.house.title}</p>
          <p className="text-sm text-gray-400">{property.description}</p>

          <p className="text-sm text-black">
            <b>{t("posted by")} </b>{" "}
            {property.house.postedBy?.userAccount?.first_name}{" "}
            {property.house.postedBy?.userAccount?.last_name}
          </p>
        </div>
        <br />
        <hr />
        <div className="text-sm text-black py-2">
          <p className="flex items-center">
            <b>{t("About Reservations")}</b>
          </p>
          <p className="text-sm text-black py-1">
            {t("Reservation ID")}: {property.id}
          </p>
          <p className="text-sm text-black py-1">
            {t("Requested Reservation Price")}: {property.house.price}
          </p>
          <p className="text-sm text-black py-1">
            {t("Unit of Price")}: {property.house.unit}
          </p>
          <p className="text-sm text-black py-1">
            {t("Reservation Check in")} :{property.checkIn}
          </p>
          <p className="text-sm text-black py-1">
            {t("Reservation Check out")} : {property.checkOut}
          </p>
          <p className="text-sm text-black py-1">
            {t("Reservation Decision time")} :{" "}
            {property.decisionTime || "Pending"}
          </p>
          <p className="text-sm text-black py-1">
            {t("Reservation Decision")} : <b>{property.status}</b>
          </p>
        </div>
        <br />
        <hr />
        <div className="text-sm text-black py-2">
          <p className="flex items-center">
            <b>{t("About Host")}</b>
          </p>
          <p className="text-sm text-black py-1">
            {t("Phone number")}: {property.house.postedBy?.phoneNumber}
            <button
              className="ml-2 px-1 py-1 text-white text-xs bg-green-500 rounded-lg"
              onClick={() =>
                window.open(`tel:${property.house.postedBy?.phoneNumber}`)
              }
            >
              {t("Call")}
            </button>
            <button
              className="ml-2 px-1 py-1 text-white text-xs bg-blue-500 rounded-lg"
              onClick={() =>
                window.open(`sms:${property.house.postedBy?.phoneNumber}`)
              }
            >
              {t("Message")}
            </button>
          </p>
          <p className="text-sm text-black py-1 px-1">
            {t("Telegram Username")}:
            <a
              href={`http://t.me/${property.house.postedBy?.userAccount?.username}`}
            >
              {property.house.postedBy?.userAccount?.username}
            </a>
          </p>
        </div>
        {/* Map through items and display the emoji and description */}
        <div
          className="flex flex-col mt-2"
          style={{
            backgroundColor: "#f2f4f7",
            borderRadius: "12px",
            padding: "16px",
          }}
        >
          <p className="text-black font-bold" style={{ fontSize: "12px" }}>
            {t("Facilities")}
          </p>

          <div style={{ overflow: "hidden" }}>
            <div className="grid grid-cols-4 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-3 gap-2 mt-2">
              {facilitiesToRender.map((item, index) => {
                const trimmedItem = item.trim();
                const emojiOrIcon = emojiMap[trimmedItem];

                return (
                  <div
                    key={index}
                    className="flex flex-col items-center text-black p-2"
                  >
                    {emojiOrIcon ? (
                      <>
                        <img
                          src={emojiOrIcon}
                          alt={trimmedItem}
                          className="w-10 h-10"
                        />
                        <span className="text-[10px] mt-2 text-center">
                          {trimmedItem}
                        </span>
                      </>
                    ) : (
                      <span className="text-[10px] text-center">
                        {trimmedItem}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div className="text-xs text-black py-4">
          <p className="flex items-center">
            <img
              src={locationImg}
              alt="location icon"
              width={25}
              height={25}
              className="mr-2"
            />
            {property.house.city},{property.house.specificAddress}
          </p>
        </div>
        <br />
        <hr></hr>
        <p className="text-black text-sm py-2">{t("Book cancellation")}</p>
        <p className="text-gray-500 py-1" style={{ fontSize: "12px" }}>
          {t(
            "Any cancellation policy details (e.g., “No refund for cancellations made less than 24 hours before check-in”)"
          )}
        </p>
        <div className="flex items-center justify-between p-2 w-full">
          <div className="w-full">
            <button
              className="text-black text-xs py-2 px-4 rounded-xl w-full"
              style={{ backgroundColor: "#ffff", border: "solid black" }}
              onClick={openModal}
            >
              {t("Cancel the booking")}
            </button>
          </div>
        </div>
        {/* Render the modal if it's open */}
      </div>
      {isModalOpen && (
        <BookCancelModal
          onClose={closeModal}
          setShowCancelModal={setShowCancelModal}
          onConfirm={() =>
            handleConfirmCancel(
              property.id,
              property.user?.userAccount?.username
            )
          }
        />
      )}
    </>
  );
};

export default PendingBook;
